export const tinFormat = (value) => {
  const first = value.substring(0, 3);
  const second = value.substring(3, 6);
  const last = value.substring(6, value.length);

  return (
    first +
    (second.length ? "-" + second : "") +
    (last.length ? "-" + last : "")
  );
};

export const getBase64 = (file, onLoadCallback) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
  });
};

export const getCurrencyAmount = (number) => {
  const fixedNumber = Number.parseFloat(number).toFixed(2);
  return String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const stringUtils = {
  tinFormat,
  getBase64,
  getCurrencyAmount,
};

export default stringUtils;
